import { Chakra } from "@airhelp/react-ui-components";
import THead from "./THead";
import TBody from "./TBody";
import ScrollWrapper from "./ScrollWrapper";
import type { TableProps } from "./Table.d";

const { Table: ChakraTable } = Chakra;

const Table = ({ rows, getTableProps, headerGroups, getTableBodyProps, prepareRow }: TableProps) => (
  <ScrollWrapper>
    <ChakraTable {...getTableProps()} mb={2}>
      <THead headerGroups={headerGroups} />
      <TBody rows={rows} getTableBodyProps={getTableBodyProps} prepareRow={prepareRow} />
    </ChakraTable>
  </ScrollWrapper>
);

export default Table;
